import { twMerge } from 'tailwind-merge';

import {
  ActivityColumnKey,
  PENDENCIES_ACTIVITY_COLUMN_ORDER,
} from '@/components/activity/tables/types';
import { SmartTable, SmartTableProps } from '@/components/ui/daisy';
import useActivityColumns from '@/data/hook/shared/activities/tables/useActivityColumns';
import { ActivityProgressOrdering } from '@/data/services/activityProgressServices';
import { ActivityProgress } from '@/models/ActivityProgress';
import { OrderingKey } from '@/models/Filter';

type ActivityTableProps = Omit<
  SmartTableProps<ActivityProgress, ActivityColumnKey>,
  'columns' | 'getRowKey'
> & {
  ordering?: ActivityProgressOrdering;
  onToggleOrdering: (field: OrderingKey<ActivityProgressOrdering>) => void;
};

export default function ActivityTable({
  ordering,
  onToggleOrdering,
  order = PENDENCIES_ACTIVITY_COLUMN_ORDER,
  className,
  ...smartTableProps
}: ActivityTableProps) {
  const columns = useActivityColumns({
    ordering,
    onToggleOrdering,
  });

  return (
    <SmartTable
      columns={columns}
      order={order}
      getRowKey={activityProgress => activityProgress.id}
      className={twMerge('table-fixed', className)}
      {...smartTableProps}
    />
  );
}
